import { ChooseTeamAction } from './ChooseTeamAction';
import { Reducer } from 'redux';
import { TeamMap } from '../api/model';
import type { MenuAction } from '../Menu/MenuActions';
import { LoginAction, LoginEvents } from '../Login/LoginAction';

export type ChooseTeamReducer = {
  teams: TeamMap;
  loading: boolean;
};

/**
 * The initial state of the loaded teams.
 * Constant to be used for compare.
 */
export const NO_TEAMS_LOADED = {};

const initialState: ChooseTeamReducer = {
  teams: NO_TEAMS_LOADED,
  loading: false,
};

const chooseTeamReducer: Reducer<ChooseTeamReducer> = (
  state: ChooseTeamReducer = initialState,
  action: ChooseTeamAction | MenuAction | LoginAction
) => {
  switch (action.type) {
    case LoginEvents.LOGOUT:
      return initialState;
    case 'LOADTEAMS_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'LOADTEAMS_SUCCESS':
      return {
        ...state,
        loading: false,
        teams: action.loadTeamsResponse,
      };
    case 'LOADTEAMS_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'SET_FAVORITE_STATUS_SUCCESS':
      return {
        ...state,
        teams: Object.fromEntries(
          Object.entries(state.teams).map(([key, team]) => [
            key,
            key === action.teamId
              ? { ...team, favoriteStatus: action.status }
              : team,
          ])
        ),
      };
    case 'SET_NOTIFICATION_STATUS_SUCCESS':
      return {
        ...state,
        teams: Object.fromEntries(
          Object.entries(state.teams).map(([key, team]) => [
            key,
            key === action.teamId
              ? { ...team, notificationStatus: action.status }
              : team,
          ])
        ),
      };
  }
  return state;
};

export default chooseTeamReducer;
